<ng-container *ngIf="allowAccess; else loader">
  <div fxLayout="column" class="addons-container" [ngClass]="{'is-summary': isSummary}">
    <!-- Check if addons exist and are not empty -->
    <div *ngIf="(addOns$ | async) as addOns">
      <ng-container *ngIf="addOns.length > 0; else emptyState">
        <!-- Optional Add-ons Section (Visible only when addons exist) -->
        <div class="optional-addons" [ngClass]="{'is-choose-plan-page': isChoosePlanPage}" fxLayout="column" fxLayoutGap="8px" fxLayoutAlign="center center">
          <h2 class="addons-title" [ngClass]="{'is-summary': isSummary}">{{ 'billing.addonsPageTitle' | translate }}</h2>
          <p class="addons-description is-summary" *ngIf="isSummary">
            {{ 'billing.addonsPageSummarySubTitle' | translate }}
          </p>
        </div>

        <!-- Add-ons Cards -->
        <div class="addons-grid" [ngClass]="{'is-summary': isSummary, 'is-choose-plan-page': isChoosePlanPage}">
          <mat-card *ngFor="let addOn of addOns; let i = index" fxLayout="column" class="card" [ngClass]="{'card-summary': isSummary, 'has-confirmation': isConfirmingPurchase(i) || isPaymentError(i), 'being-removed': addOn.isBeingRemoved}">

            <!-- Purchase Confirmation Dialog Content -->
            <div *ngIf="isConfirmingPurchase(i)" class="confirmation-dialog" fxLayout="column" fxLayoutAlign="center center">
              <div class="confirmation-content" fxLayout="column" fxLayoutAlign="center center">
                <!-- Billing Icon and Text Inline -->
                <div class="confirmation-header" fxLayout="row" fxLayoutAlign="start" fxLayoutGap="16px">
                  <div class="billing-icon">
                    <mat-icon svgIcon="credit_card_twotone"></mat-icon>
                  </div>

                <!-- Confirmation Text -->
                <div class="confirmation-text">
                  <p *ngIf="!isDiscountApplied(i)" [innerHTML]="'billing.addonConfirmationText' | translate: {price: (addOn.calculatedPrice || addOn.price) | priceNotation}"></p>
                  <p *ngIf="isDiscountApplied(i)">
                    {{ getConfirmationTextPrefix() }}
                    <span class="discount-price-display">
                      <span class="original-price">{{ getOriginalPrice(addOn) }}</span>
                      <span class="discounted-price">{{ getDiscountedPrice(addOn, i) }}</span>
                    </span>
                    {{ getConfirmationTextSuffix() }}
                  </p>
                </div>
              </div>

              <!-- Discount Code Section (only shown when feature flag is enabled) -->
              <div *ngIf="shouldShowDiscountSection(i)" class="discount-code-section">
                <div class="discount-code-spacer"></div>
                <!-- Discount Code Link (shown by default when no discount applied) -->
                <div *ngIf="!isShowingDiscountInput(i) && !isDiscountApplied(i)" class="discount-code-link">
                  <a href="#" class="discount-code-text" (click)="showDiscountInput(i); $event.preventDefault()">{{ 'billing.discountCodeLink' | translate }}</a>
                </div>

                <!-- Discount Applied Success Message -->
                <div *ngIf="isDiscountApplied(i)" class="discount-success-message">
                  <div class="discount-applied-text">
                    <span class="success-text">{{ getAppliedDiscountText(i) }}</span>
                    <a href="#" class="delete-code-link" (click)="clearAppliedDiscount(i); $event.preventDefault()">{{ 'billing.deleteDiscountCode' | translate }}</a>
                  </div>
                </div>

                <!-- Discount Code Input (shown when link is clicked and no discount applied) -->
                <div *ngIf="isShowingDiscountInput(i) && !isDiscountApplied(i)" class="discount-code-input-container">
                  <div class="input-row">
                    <input
                      type="text"
                      class="discount-code-input"
                      [placeholder]="'billing.addDiscountCodePlaceholder' | translate"
                      [(ngModel)]="discountCodeValue"
                      (keydown)="onDiscountCodeKeyPress($event, i)"
                      (input)="clearDiscountValidationError()"
                      #discountInput
                      autofocus>
                    <button
                      type="button"
                      class="apply-discount-btn"
                      (click)="applyDiscountCode(i)"
                      [disabled]="!discountCodeValue.trim() || isValidatingDiscount(i)">
                      <mat-spinner *ngIf="isValidatingDiscount(i)" diameter="16" class="button-spinner"></mat-spinner>
                      <span *ngIf="!isValidatingDiscount(i)">{{ 'billing.applyDiscountCode' | translate | uppercase }}</span>
                    </button>
                  </div>

                  <!-- Discount Validation Error (shown directly below input) -->
                  <div *ngIf="getDiscountValidationError()" class="discount-error-message">
                    {{ getDiscountValidationError() }}
                  </div>
                </div>
              </div>

              <!-- Action Buttons -->
              <div class="confirmation-actions" fxLayout="row" fxLayoutGap="8px">
                  <button
                    mat-stroked-button
                    class="cancel-btn"
                    (click)="cancelPurchaseConfirmation()">
                    {{ 'common.cancel' | translate | uppercase }}
                  </button>
                  <button
                    mat-stroked-button
                    class="confirm-btn"
                    [ngClass]="{'loading': isLoadingBuyNow(i)}"
                    (click)="confirmPurchase(addOn, i)"
                    [disabled]="isConfirmDisabled(i)">
                    <mat-spinner *ngIf="isLoadingBuyNow(i)" diameter="16" class="button-spinner"></mat-spinner>
                    <span *ngIf="!isLoadingBuyNow(i)">{{ 'common.confirm' | translate | uppercase }}</span>
                  </button>
                </div>
              </div>
            </div>

            <!-- Payment Error Dialog Content -->
            <div *ngIf="isPaymentError(i)" class="confirmation-dialog" fxLayout="column" fxLayoutAlign="center center">
              <!-- Close Button -->
              <div class="close-button-container">
                <button
                  mat-icon-button
                  class="close-btn"
                  (click)="cancelPaymentError()"
                  aria-label="Close dialog">
                  <mat-icon>close</mat-icon>
                </button>
              </div>
              <div class="confirmation-content" fxLayout="column" fxLayoutAlign="center center">
                <!-- Error Icon and Text Inline -->
                <div class="confirmation-header" fxLayout="row" fxLayoutAlign="start" fxLayoutGap="16px">
                  <div class="error-icon">
                    <mat-icon svgIcon="error_twotone"></mat-icon>
                  </div>

                  <!-- Error Text -->
                  <div class="confirmation-text">
                    <p>{{ ('upsellPaymentFailed.message' | translate) }}</p>
                  </div>
                </div>

                <!-- Action Buttons -->
                <div class="confirmation-actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="12px">
                  <button
                    mat-stroked-button
                    class="update-payment-btn"
                    (click)="onUpdatePaymentMethod()">
                    {{ 'billing.paymentSummary.paymentError.updatePaymentMethod' | translate | uppercase }}
                  </button>
                  <button
                    mat-stroked-button
                    class="try-again-btn"
                    (click)="onTryAgain()">
                    {{ 'billing.paymentSummary.paymentError.tryAgain' | translate | uppercase }}
                  </button>
                </div>
              </div>
            </div>

            <!-- Normal Card Content -->
            <div *ngIf="!isConfirmingPurchase(i) && !isPaymentError(i)">
              <div fxLayout="row" fxLayoutAlign="space-between center" class="card-header">
                <div [fxLayout.gt-xs]="isSummary ? 'column' : 'row'" [fxLayoutAlign.gt-xs]="isSummary ? 'start start' : 'start center'">
                  <div class="img-container">
                    <img [src]="isSummary && addOn.imgSrcSummary ? addOn.imgSrcSummary : addOn.imgSrc" [alt]="addOn.imgAlt" [width]="addOn.imgWidth" [ngClass]="{'mb-2': isSummary}">
                  </div>
                  <div class="title" [ngClass]="{'is-summary': isSummary}">{{ addOn.title }}</div>
                </div>
              </div>

              <!-- Description shown first when isSummary is true -->
              <p *ngIf="isSummary" class="description" [ngClass]="{'is-summary': isSummary}">
                {{ addOn.description }}
              </p>

              <!-- Pricing div -->
              <div class="pricing" [ngClass]="{'is-summary': isSummary}">
                <div class="price-container" [ngClass]="{'purchased': addOn.purchased}">
                  <div class="price-container-inner">
                    <div class="price"
                         [ngClass]="{'is-summary': isSummary, 'purchased': addOn.purchased, 'clickable': shouldShowPriceNotation}"
                         [matTooltip]="!shouldShowPriceNotation ? null : getFullPriceForTooltip(addOn)"
                         [matTooltipDisabled]="shouldShowPriceNotation"
                         matTooltipPosition="above"
                         (click)="shouldShowPriceNotation && showTooltipOnMobile($event, addOn)"
                         (keydown)="onPriceKeyDown($event, addOn)">
                      {{ getFormattedAddonPrice(addOn) }}
                    </div>
                    <div class="price-subtitle is-summary">{{ addOn.calculatedSubtitle || addOn.subtitle }}</div>
                  </div>
                  <!-- Activation info -->
                  <div *ngIf="shouldShowActivationInfo(addOn) || isAddonActivated(addOn)" class="activation-info">
                    <mat-icon *ngIf="isAddonActivated(addOn)" class="activation-icon" [ngClass]="{'activated': isAddonActivated(addOn), 'pending': !isAddonActivated(addOn)}">
                      {{ getActivationStatusIcon(addOn) }}
                    </mat-icon>
                    <span class="activation-text" [ngClass]="{'activated': isAddonActivated(addOn), 'pending': !isAddonActivated(addOn)}">
                      {{ getActivationStatusText(addOn) }}
                    </span>
                    <app-info *ngIf="!isAddonActivated(addOn)" tooltip="{{ 'billing.activationInfoTooltip' | translate }}"></app-info>
                  </div>
                </div>
                <!-- When in summary mode, show subtitle on left and button on right -->
                <div *ngIf="isSummary" fxLayout="column" fxLayoutAlign="space-between center" class="full-width">
                  <!-- Callout notification for addon purchase -->
                  <div *ngIf="addOn.linkname === 'UAR' && shouldShowBuyNowButton(addOn)"
                    callout #calloutRightColumn
                    [attr.id]="addOn.linkname === 'UAR' ? 'buyNowButton' : null"
                    style="display:flex">
                    <app-callout
                      id="selfServeAddonAwareness"
                      [origin]="calloutRightColumn"
                      position="left"
                      title="{{ 'billing.addonPurchaseTitle' | translate }}"
                      description="{{ 'billing.addonPurchaseDescription' | translate }}"
                      dismissButtonLabel="{{ 'common.gotIt' | translate | uppercase}}"
                      [timeout]="1000"
                      [saveVisitByDB]="true"
                      [enableScrollReposition]="true"
                    [panelClass]="'callout-right-add-on self-serve-addons'">
                  </app-callout>
                  </div>
                  <button
                    *ngIf="shouldShowUpgradeButton(addOn)"
                    (click)="goToChoosePlan(addOn)"
                    mat-raised-button
                    color="accent"
                    class="buy-now-btn">
                    {{ 'common.upgrade' | translate | uppercase }}
                  </button>
                  <button
                    *ngIf="shouldShowBuyNowButton(addOn)"
                    (click)="buyNow(addOn?.addonIds, i)"
                    mat-raised-button
                    color="accent"
                    class="buy-now-btn"
                    [disabled]="isLoadingBuyNow(i)">
                    <mat-spinner *ngIf="isLoadingBuyNow(i)" diameter="16" class="button-spinner"></mat-spinner>
                    <span *ngIf="!isLoadingBuyNow(i)">{{ getBuyNowButtonLabel() }}</span>
                  </button>

                  <button
                    *ngIf="!addOn.purchased && !addOn.isBeingRemoved && (!addOn?.selfServeAddon || shouldShowChatWithSalesButton || currentPlan?.billingMode === 'invoicing')"
                      (click)="openAddonsLandingPage($event, addOn.linkname)"
                      mat-button
                      color="accent"
                      class="contact-sales-btn">
                    {{ 'billing.addonsCtaButton' | translate | uppercase }}
                  </button>
                  <button
                    *ngIf="addOn.purchased"
                    mat-button
                    color="accent"
                    class="addons-added-btn"
                    [ngClass]="{'loading': isLoadingRemove(i)}"
                    (mouseenter)="onAddonButtonMouseEnter(i)"
                    (mouseleave)="onAddonButtonMouseLeave()"
                    (click)="onAddonsAddedButtonClick($event, i)"
                    [disabled]="isLoadingRemove(i) || addOn.isBeingRemoved">
                    <mat-spinner *ngIf="isLoadingRemove(i)" diameter="16" class="button-spinner"></mat-spinner>
                    <mat-icon inline class="added-icon" *ngIf="!isLoadingRemove(i)">{{ getAddonButtonIcon(addOn, i) }}</mat-icon>
                    <span *ngIf="!isLoadingRemove(i)">
                      {{ getAddonButtonText(addOn, i) }}
                    </span>
                  </button>
                </div>
                <!-- New button layout for non-summary mode with both BUY NOW and CHAT WITH SALES -->
                <div *ngIf="!isSummary && !addOn.isBeingRemoved" class="button-container">
                  <button
                    (click)="openAddonsLandingPage($event, addOn.linkname)"
                    mat-stroked-button
                    color="primary"
                    class="chat-sales-btn">
                    {{ 'billing.addonsCtaButton' | translate | uppercase }}
                  </button>
                </div>
              </div>

              <!-- Description shown last when isSummary is false (default) -->
              <p *ngIf="!isSummary" class="description">
                {{ addOn.description }}
              </p>
            </div>
          </mat-card>
        </div>
      </ng-container>
    </div>
  </div>
</ng-container>

<!-- Empty State -->
<ng-template #emptyState>
  <div class="addons-empty-state-container" fxLayout="column" fxLayoutAlign="center center">
    <app-empty-state fxFlex>
      <span title>{{ 'common.noAddonsTitle' | translate }}</span>
      <span description>{{ 'common.noAddonsDescription' | translate }}</span>
    </app-empty-state>
  </div>
</ng-template>

<ng-template #loader>
  <mat-spinner diameter="50" class="absolute-centered"></mat-spinner>
</ng-template>
